import { render, staticRenderFns } from "./ErpLiRunBiao.vue?vue&type=template&id=576e5278&scoped=true&"
import script from "./ErpLiRunBiao.vue?vue&type=script&lang=js&"
export * from "./ErpLiRunBiao.vue?vue&type=script&lang=js&"
import style0 from "./ErpLiRunBiao.vue?vue&type=style&index=0&id=576e5278&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "576e5278",
  null
  
)

export default component.exports